import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'generarObjetoConceptosAdicionales'
})

// Obtiene el servicio seleccionado y arma un objeto con los conceptos adicionales
export class GenerarObjetoConceptosAdicionalesPipe implements PipeTransform {
  transform(servicio: any): any {
    // Objeto final de conceptos
    let conceptosAdicionales:any = {
      total : 0,
      conceptos : [],
      // El total cliente t los conceptos cliente, son los objetos que están permitidos por el cliente para ver
      totalCliente : 0,
      conceptosCliente : []
    };

    // Hace un loop por todos los conceptos adicionales
    for(let conceptoId in servicio.conceptosAdicionales){
        var descripcion = "";
        if(servicio.punto_origen)
        {
            descripcion = servicio.conceptosAdicionales[conceptoId].nombre
        }
        else {
            descripcion = servicio.conceptosAdicionales[conceptoId].descripcion
        }
      let objConcepto = {
        id : conceptoId,
        descripcion : descripcion,
          cantidad : servicio.conceptosAdicionales[conceptoId].cantidad,
        precio : servicio.conceptosAdicionales[conceptoId].precio,
        visibleCliente : (!servicio.conceptosAdicionales[conceptoId].hasOwnProperty('visibleCliente') || servicio.conceptosAdicionales[conceptoId].visibleCliente) ? true : false
      };

      // Checa si el concepto adicional es visible para el cliente. Hay unos conceptos que no tenían la bandera aún
      if(objConcepto.visibleCliente)
      {
        // Añade el precio del concepto al precio que puede ver el cliente y lo agrega a los conceptos visibles
        conceptosAdicionales.totalCliente += objConcepto.precio;
        conceptosAdicionales.conceptosCliente.push(objConcepto);
      }

      // Agrega al precio total, todos los precios de los conceptos
      conceptosAdicionales.total += (objConcepto.precio * objConcepto.cantidad);
      // Agrega el concepto al arreglo de conceptos
      conceptosAdicionales.conceptos.push(objConcepto);
    }

    return conceptosAdicionales;
  }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/generar-objeto-conceptos-adicionales.pipe.ts